// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { LegendsFeedbackRepresentation } from './LegendsFeedbackRepresentation'
import {
  LegendsFeedbackRepresentationFromJSON,
  LegendsFeedbackRepresentationFromJSONTyped,
  LegendsFeedbackRepresentationToJSON,
} from './LegendsFeedbackRepresentation'

/**
 *
 * @export
 * @interface ActivityAnswerViewModel
 */
export interface ActivityAnswerViewModel {
  /**
   *
   * @type {number}
   * @memberof ActivityAnswerViewModel
   */
  words?: number | null
  /**
   *
   * @type {number}
   * @memberof ActivityAnswerViewModel
   */
  uniqueWords?: number | null
  /**
   *
   * @type {string}
   * @memberof ActivityAnswerViewModel
   */
  answerId: string
  /**
   *
   * @type {string}
   * @memberof ActivityAnswerViewModel
   */
  resultId: string
  /**
   *
   * @type {string}
   * @memberof ActivityAnswerViewModel
   */
  blockId: string
  /**
   *
   * @type {string}
   * @memberof ActivityAnswerViewModel
   */
  answerText?: string | null
  /**
   *
   * @type {string}
   * @memberof ActivityAnswerViewModel
   */
  plainText?: string | null
  /**
   *
   * @type {number}
   * @memberof ActivityAnswerViewModel
   */
  score?: number | null
  /**
   *
   * @type {LegendsFeedbackRepresentation}
   * @memberof ActivityAnswerViewModel
   */
  legendsFeedback?: LegendsFeedbackRepresentation
}

/**
 * Check if a given object implements the ActivityAnswerViewModel interface.
 */
export function instanceOfActivityAnswerViewModel(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'answerId' in value
  isInstance = isInstance && 'resultId' in value
  isInstance = isInstance && 'blockId' in value

  return isInstance
}

export function ActivityAnswerViewModelFromJSON(
  json: any,
): ActivityAnswerViewModel {
  return ActivityAnswerViewModelFromJSONTyped(json, false)
}

export function ActivityAnswerViewModelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ActivityAnswerViewModel {
  if (json === undefined || json === null) {
    return json
  }
  return {
    words: !exists(json, 'words') ? undefined : json['words'],
    uniqueWords: !exists(json, 'unique_words')
      ? undefined
      : json['unique_words'],
    answerId: json['answer_id'],
    resultId: json['result_id'],
    blockId: json['block_id'],
    answerText: !exists(json, 'answer_text') ? undefined : json['answer_text'],
    plainText: !exists(json, 'plain_text') ? undefined : json['plain_text'],
    score: !exists(json, 'score') ? undefined : json['score'],
    legendsFeedback: !exists(json, 'legends_feedback')
      ? undefined
      : LegendsFeedbackRepresentationFromJSON(json['legends_feedback']),
  }
}

export function ActivityAnswerViewModelToJSON(
  value?: ActivityAnswerViewModel | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    words: value.words,
    unique_words: value.uniqueWords,
    answer_id: value.answerId,
    result_id: value.resultId,
    block_id: value.blockId,
    answer_text: value.answerText,
    plain_text: value.plainText,
    score: value.score,
    legends_feedback: LegendsFeedbackRepresentationToJSON(
      value.legendsFeedback,
    ),
  }
}
